// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8299 ? "user-status-modal" : chunkId) + "-" + chunkId + ".js?v=" + {"923":"2686613ba9d88601b889","8299":"244ab3f6d6a7a5edd2b3","8321":"1e9a8023ef8296a459a5"}[chunkId] + "";
};